import * as apiFactory from "./ApiFactory";
import { EvidoxConfiguration } from "@/models/EvidoxConfiguration";

import type { ClientSetting } from "@/models/ClientSetting";

export async function settings(clientName: string): Promise<ClientSetting> {
  const client = await apiFactory.WithBearer();
  return await client.get<ClientSetting>(["api/settings", clientName]);
}
export async function evidox(): Promise<EvidoxConfiguration> {
  const client = await apiFactory.WithBearer();
  return await client.get<EvidoxConfiguration>(`api/settings/evidox`);
}
